import { ROOT_DIR_ID } from 'shared/constants/directory';
import { resolveExportDocumentName } from '../resolveExportDocumentName';

/** The file becomes a new documentation in a directory. */
export type ExportToNewDocumentationDto = {
  isParentRootDirectory: boolean;
  name: string;
  number: string;
  parentId?: string;
};

/** The file becomes a new version of an existing documentation; the backend refuses any other field (422). */
export type ExportAsVersionDto = {
  targetDocumentationId: string;
};

export type ExportDocumentOutDto = ExportToNewDocumentationDto | ExportAsVersionDto;

export function isExportAsVersionDto(
  payload: ExportDocumentOutDto
): payload is ExportAsVersionDto {
  return 'targetDocumentationId' in payload;
}

/** The name of the documentation the export creates; none when the file becomes a version of an existing one. */
export function getNewDocumentationName(payload: ExportDocumentOutDto): string | undefined {
  return isExportAsVersionDto(payload) ? undefined : payload.name;
}

export function createExportAsVersionPayload(
  targetDocumentationId: string
): ExportAsVersionDto {
  return { targetDocumentationId };
}

export type ExportPayloadParams = {
  currentDirectoryId: string;
  fileTitle?: string;
};

export function createExportPayload({
  currentDirectoryId,
  fileTitle,
}: ExportPayloadParams): ExportToNewDocumentationDto {
  const isRoot = currentDirectoryId === ROOT_DIR_ID;
  const normalizedName = resolveExportDocumentName({
    preferredName: fileTitle,
  });

  return {
    isParentRootDirectory: isRoot,
    name: normalizedName,
    number: '',
    ...(isRoot ? {} : { parentId: currentDirectoryId }),
  };
}
